// src/admin/Admin.jsx

import { signOut } from "firebase/auth";
import { auth } from "../firebase/config";

import AdminHero from "./sections/AdminHero";
import AdminBio from "./sections/AdminBio";
import AdminMilestones from "./sections/AdminMilestones";
import AdminGallery from "./sections/AdminGallery";
import AdminBlogs from "./sections/AdminBlogs";
// (later we add AdminBio, AdminGallery, AdminBlogs)

import "./admin.css";

export default function Admin() {
  return (
    <div className="admin">

      {/* ================= SIDEBAR ================= */}
      <aside className="admin-sidebar">
        <h2>Admin Panel</h2>

        <nav>
          <button>Hero</button>
          <button>Biography</button>
          <button>Milestones</button>
          <button>Gallery</button>
          <button>Blogs</button>
        </nav>

        <button className="logout-btn" onClick={() => signOut(auth)}>
          Logout
        </button>
      </aside>

      {/* ================= CONTENT ================= */}
      <main className="admin-content">

        <h1>Dashboard</h1>

        {/* HERO SECTION */}
        <section className="admin-section">
          <AdminHero />
        </section>

        {/* NEXT SECTIONS (we will build step by step) */}
        <AdminBio />
        <AdminMilestones />
        <AdminGallery />
        <AdminBlogs />

      </main>

    </div>
  );
}
